import React, { useState } from 'react';
import { Save, CheckCircle } from 'lucide-react';
import { Button } from '../../ui';

const FEATURES = [
  { key: 'assignments',          label: 'Assignments',           description: 'Task assignment workflows' },
  { key: 'emailSignal',          label: 'Email Signals',         description: 'Email signal dashboards' },
  { key: 'strategicInitiatives', label: 'Strategic Initiatives', description: 'Cross-org initiative tracking' },
  { key: 'recurringTasks',       label: 'Recurring Tasks',       description: 'Scheduled recurring checklists' },
];

const MOCK_TENANTS = [
  { id: 1, name: 'Riverside Health',     assignments: true,  emailSignal: true,  strategicInitiatives: false, recurringTasks: true },
  { id: 2, name: 'Summit Care',          assignments: true,  emailSignal: false, strategicInitiatives: false, recurringTasks: true },
  { id: 3, name: 'Valley Hospital',      assignments: false, emailSignal: false, strategicInitiatives: false, recurringTasks: false },
  { id: 4, name: 'Coastal Medical',      assignments: true,  emailSignal: true,  strategicInitiatives: true,  recurringTasks: true },
];

function Toggle({ checked, onChange }) {
  return (
    <label style={{ position: 'relative', display: 'inline-block', width: 40, height: 22, cursor: 'pointer' }}>
      <input type="checkbox" checked={checked} onChange={onChange} style={{ opacity: 0, width: 0, height: 0 }} />
      <span style={{
        position: 'absolute', inset: 0, borderRadius: 11,
        background: checked ? 'var(--aqua)' : 'var(--navy-light)',
        transition: '0.2s',
      }}>
        <span style={{
          position: 'absolute', height: 16, width: 16, left: checked ? 20 : 3, bottom: 3,
          background: '#fff', borderRadius: '50%', transition: '0.2s',
        }} />
      </span>
    </label>
  );
}

export default function FeatureFlagsPage() {
  const [tenants, setTenants] = useState(MOCK_TENANTS);
  const [saved, setSaved] = useState(null);

  const toggle = (tenantId, featureKey) => {
    setTenants(ts => ts.map(t => t.id === tenantId ? { ...t, [featureKey]: !t[featureKey] } : t));
  };

  const save = (tenantId) => {
    setSaved(tenantId);
    setTimeout(() => setSaved(null), 2000);
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Feature Flags</h1>
        <p className="dashboard-subtitle">Enable or disable product features per tenant.</p>
      </div>

      <div className="bg-nn-white rounded-card-lg shadow-card overflow-hidden relative">
        <div style={{ padding: 0 }}>
          <table className="nn-table">
            <thead>
              <tr>
                <th style={{ minWidth: 160 }}>Tenant</th>
                {FEATURES.map(f => (
                  <th key={f.key} style={{ textAlign: 'center' }}>
                    <div>{f.label}</div>
                    <div className="text-text-dark-secondary" style={{ fontSize: 10, fontWeight: 400, marginTop: 2 }}>{f.description}</div>
                  </th>
                ))}
                <th style={{ width: 80 }} />
              </tr>
            </thead>
            <tbody>
              {tenants.map(tenant => (
                <tr key={tenant.id}>
                  <td style={{ fontWeight: 600 }}>{tenant.name}</td>
                  {FEATURES.map(f => (
                    <td key={f.key} style={{ textAlign: 'center' }}>
                      <Toggle checked={tenant[f.key]} onChange={() => toggle(tenant.id, f.key)} />
                    </td>
                  ))}
                  <td style={{ textAlign: 'center' }}>
                    {saved === tenant.id ? (
                      <CheckCircle size={18} className="text-green" style={{ color: 'var(--green)' }} />
                    ) : (
                      <Button variant="primary" size="sm" onClick={() => save(tenant.id)}
                        style={{ display: 'inline-flex', gap: 4, margin: '0 auto' }}>
                        <Save size={12} /> Save
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
